// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { createFileRoute, Link, useParams } from '@tanstack/react-router';

// material ui icons
import AddRoundedIcon from '@mui/icons-material/AddRounded';

// material ui
import { IconButton, Tooltip } from '@mui/material';

// api
import { useGetDevicesByAccountQuery } from '@/api/recalc/endpoints/devicesApiSlice';

// shared components
import { WritableOnly } from '@/components/access-control';
import PageContainer from '@/components/layout/PageContainer';
import PageHeader from '@/components/layout/PageHeader';
import LinearLoadingIndicator from '@/components/ui/progress/LinearLoadingIndicator';

// feature-components
import DeviceDataGrid from '@/features/devices/components/DeviceDataGrid';

import { skipToken } from '@reduxjs/toolkit/query';

export const Route = createFileRoute('/$accountId/_admin/devices/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('units-gateways-sensors');
  const account = useParams({ strict: false });
  const accountId = account.accountId ? Number(account.accountId) : null;

  const {
    data: devices,
    isLoading,
    isFetching,
  } = useGetDevicesByAccountQuery(
    accountId
      ? {
          accountId,
          includeFields: ['MappedUnits'],
        }
      : skipToken,
  );

  return (
    <>
      <LinearLoadingIndicator isLoading={isLoading || isFetching} />
      <PageContainer maxWidth="xl" sx={{ py: 2 }}>
        <PageHeader title={t('devices.overviewTitle')} disableArrow={true}>
          <WritableOnly>
            <Tooltip title={t('devices.createDevice')} placement="top">
              <IconButton
                component={Link}
                to="register"
                size="small"
                sx={{ borderRadius: 2 }}
              >
                <AddRoundedIcon />
              </IconButton>
            </Tooltip>
          </WritableOnly>
        </PageHeader>

        <DeviceDataGrid
          accountId={accountId ?? 0}
          devices={devices}
          isLoading={isLoading || isFetching}
        />
      </PageContainer>
    </>
  );
}
